<template>
  <!-- make sure if input exist -->
  <div v-if="input && input.type !== 'none'">
    <!-- <pre>{{input}}</pre> -->

    <v-snackbar
      v-model="snackbar"
      color="#161520"
      :timeout="6000"
      top
      multi-line
    >
      <span v-html="snackbarMessage"></span>
      <v-btn
        dark
        text
        color="#f12d57"
        @click="snackbar = false"
      >
        {{ $t("ask-box.snackbar.btn-1") }}
      </v-btn>
    </v-snackbar>

    <template v-if="input.type === 'textfield'">
      <TextField
        @inputUpdate="inputchange"
        @noMoreDerogation="showSnack"
        :input="input"
        :maxDerogations="maxDerogations"
        :doneDerogations="doneDerogations"
        :answerid="answerid"
        :path="path"
        :disabledInputs="disabledInputs"></TextField>
    </template>

    <template v-if="input.type === 'textarea'">
      <TextArea
        @inputUpdate="inputchange"
        @noMoreDerogation="showSnack"
        :input="input"
        :maxDerogations="maxDerogations"
        :doneDerogations="doneDerogations"
        :answerid="answerid"
        :path="path"
        :disabledInputs="disabledInputs"></TextArea>
    </template>

    <template v-if="input.type === 'legend'">
      <Legend
        @inputUpdate="inputchange"
        @noMoreDerogation="showSnack"
        :input="input"
        :answerid="answerid"
        :path="path"
        :disabledInputs="disabledInputs"></Legend>
    </template>

    <template v-if="input.type === 'checkbox'">
      <CheckBox
        @inputUpdate="inputchange"
        @noMoreDerogation="showSnack"
        :input="input"
        :maxDerogations="maxDerogations"
        :doneDerogations="doneDerogations"
        :answerid="answerid"
        :path="path"
        :disabledInputs="disabledInputs"></CheckBox>
    </template>

    <template v-if="input.type === 'upload'">
      <Upload
        @inputUpdate="inputchange"
        @noMoreDerogation="showSnack"
        :input="input"
        :maxDerogations="maxDerogations"
        :doneDerogations="doneDerogations"
        :answerid="answerid"
        :path="path"
        :disabledInputs="disabledInputs"></Upload>
    </template>

    <template v-if="Array.isArray(input) && input[0] && input[0].type.indexOf('pulldown') > -1">
      <PullDown
        @inputUpdate="inputchange"
        @noMoreDerogation="showSnack"
        :input="input"
        :maxDerogations="maxDerogations"
        :doneDerogations="doneDerogations"
        :answerid="answerid"
        :path="path"
        :disabledInputs="disabledInputs"></PullDown>
    </template>

    <template v-if="Array.isArray(input) && input[0] && input[0].type.indexOf('radio') > -1">
      <Radio
        @inputUpdate="inputchange"
        @noMoreDerogation="showSnack"
        :input="input"
        :maxDerogations="maxDerogations"
        :doneDerogations="doneDerogations"
        :answerid="answerid"
        :path="path"
        :disabledInputs="disabledInputs"></Radio>
    </template>

  </div>
</template>

<script>
/* eslint-disable */
import TextField from '@/components/audits/survey/inputs/TextField'
import TextArea from '@/components/audits/survey/inputs/TextArea'
import Legend from '@/components/audits/survey/inputs/Legend'
import CheckBox from '@/components/audits/survey/inputs/CheckBox'
import Upload from '@/components/audits/survey/inputs/Upload'
import Radio from '@/components/audits/survey/inputs/Radio'
import PullDown from '@/components/audits/survey/inputs/PullDown'
import { randomBaseUrl } from '@/js/utils/randomBaseUrl'

export default {
  props: {
    input: Object|Array,
    answerid: String,
    maxDerogations: Number,
    doneDerogations: Number,
    path: String,
    disabledInputs: {
      type: Boolean,
      default: () => false
    },
    // inspector: {
    //   type: Boolean,
    //   default: () => false
    // }
  },

  components: {
    TextField: TextField,
    TextArea: TextArea,
    Legend: Legend,
    CheckBox: CheckBox,
    Upload: Upload,
    Radio: Radio,
    PullDown: PullDown
  },

  data () {
    return {
      value: '',
      valueFiles: [],
      img: null,
      snackbar: false,
      snackbarMessage: this.$t('inputs.derogation')
    }
  },

  methods: {
    inputchange () { this.$emit('inputUpdated') },

    showSnack () {
      this.snackbar = true
    }
  },

  created () {
    // if (!this.$store.getters['auth/isAuthenticated']) return
    // init the encoded responses with exception input
    if (this.input.answer && this.input.type &&
        this.input.type !== 'upload' &&
        this.input.type !== 'radio' &&
        this.input.type !== 'pulldown' &&
        this.input.type !== undefined &&
        this.input.type !== 'undefined') this.value = this.input.answer ? this.input.answer : ''

    // init upload input value if encoded answer exist
    if (this.input.type === 'upload' &&
        this.input.answer !== '' &&
        this.input.answer !== undefined &&
        this.input.answer !== 'undefined' &&
        this.input.answer !== null &&
        this.input.answer !== 'null' &&
        this.input.answer !== [] &&
        this.answerid) {

      const img = `${randomBaseUrl(0, 3)}${process.env.VUE_APP_GET_FILE_SURVEY_ENDPOINT}?valid=${encodeURIComponent(this.$store.state.auth.token)}&answerid=${encodeURIComponent(this.answerid)}&moduleid=${this.input.id}`
      this.img = img
    }// init upload input value if encoded answer exist

    // if it's radio or pulldown
    if (Array.isArray(this.input) && this.input[0]) {
      // if radio group
      if (this.input[0].type.indexOf('radio') > -1 ||
          this.input[0].type.indexOf('pulldown') > -1) {
        this.input.forEach(el => {
          if (el.answer !== '' &&
              el.answer !== 'undefined' &&
              el.answer !== undefined &&
              el.answer !== 'null' &&
              el.answer !== null) {
            this.value = el.answer
          }
        })
      }
    }
  }
}
</script>
